module.exports = __webpack_public_path__ + "app/img/logo-instagram.61210caf.svg";